<script>
	import moment from "moment";
	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";
	import { createEventDispatcher } from "svelte"
	import API from "../../API/API";
	import AppStore from "../../AppStore";
	import Dropzone from "svelte-file-dropzone";
	import { get, writable } from "svelte/store";
	import LoadState from "../../Enums/LoadState";
	import Button, { Group, GroupItem, Label, Icon } from "@smui/button";
	import DownloadHelper from "../../Helpers/DownloadHelper";
	import Tooltip from "../Tooltip.svelte";

	export let comment = null;
	export let index = -1;
	export let confirmDialog = null;
	export let showEditTools = true;

	let lastUpdated = writable( Date.now() );

	const dispatch = createEventDispatcher(); // cancel

	let deleting = false;
	let doDeleteComment = () => {
		deleting = true;
		API.delete("comments/comment/" + comment.id)
			.then((result) => {
				deleting = false;
				dispatch("delete", { comment });            
			})
			.catch((err)=>{
				deleting = false;
				AppStore.snackbar.start("Could not remove comment.", "error");
			})
			.finally(()=>{
				if (confirmDialog) {
					confirmDialog.visible.set(false);
				}
			});
	};
	let deleteComment = (commentId) => {
		if (confirmDialog) {
			confirmDialog.onConfirm = () => {
				doDeleteComment();
			};
			confirmDialog.visible.set(true);
		}
		else {
			doDeleteComment();
		}
	};

	let showingAttachmentForm = false;
	let toggleAttachmentForm = (commentId) => {
		showingAttachmentForm = !showingAttachmentForm;
	};
	let clearAttachmentForm = () => {
		files.accepted = [];
		files.rejected = [];
	};
	
	let attachmentLoadState = writable(LoadState.INIT);
	let parsingFile = writable(LoadState.INIT);
	let parsingFileError = writable("");
	let parsingFileContent = writable("");
	let files = {
		accepted: [],
		rejected: []
	};
	let resetFileUpload = () => {
		clearAttachmentForm();
		$parsingFile = LoadState.INIT;
		$parsingFileContent = "";
		$parsingFileError = "";
	};
	function handleFilesSelect(e) {
		resetFileUpload();
		$parsingFile = LoadState.LOADING;
		
		const { acceptedFiles, fileRejections } = e.detail;
		files.accepted = [...files.accepted, ...acceptedFiles];
		files.rejected = [...files.rejected, ...fileRejections];

		console.log("files", files);

		if (files.accepted.length >= 1) {
			let file = files.accepted[0];
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				console.log("Loaded");
				if (file.size > 1024 * 1024 * 4) {
					$parsingFile = LoadState.INIT;
					$parsingFileError = "Max file size is 4mb.";
				}
				else {
					$parsingFileContent = reader.result;
					$parsingFile = LoadState.LOADED;
				}
			};
			reader.onerror = function (error) {
				console.error('Error: ', error);
				$parsingFile = LoadState.INIT;
				$parsingFileError = error;
			};
		}
		else {
			files.accepted = [];
			files.rejected = [];
			$parsingFile = LoadState.INIT;
			$parsingFileError = "Please select only one file.";
		}
	}
	let submitAttachment = () => {
		if (files.accepted.length !== 1 || $parsingFile !== LoadState.LOADED) {
			return;
		}
		$attachmentLoadState = LoadState.LOADING;
		let file = files.accepted[0];

		let data = {};
		data.upload_file_name = file.name;
		data.upload_file_size_bytes = file.size;
		data.upload_file_data = $parsingFileContent.substr($parsingFileContent.indexOf(",")+1);

		API.put("/comments/comment/" + comment.id + "/attachment", data)
			.then((response) => {
				console.log(response);
				$attachmentLoadState = LoadState.INIT;
				comment.setData(response);
				showingAttachmentForm = false;
				resetFileUpload();
				$lastUpdated = Date.now();
				AppStore.snackbar.start("Attachment uploaded successfully.", "success");
			})
			.catch((err) => {
				console.error(e);
				AppStore.snackbar.start("Attachment upload failed.", "error");
			});
	};
	let downloadAttachment = (attachment) => {
		API.get("/comments/comment/" + comment.id + "/attachment?attachment_id=" + attachment.id)
			.then((response) => {
				DownloadHelper.downloadURI(response.url, attachment.fileName);
			})
			.catch((err) => {
				console.error(err);
				AppStore.snackbar.start("Attachment download failed.", "error");
			});
	};
	let viewImageAttachment = (attachment) => {
		API.get("/comments/comment/" + comment.id + "/attachment?attachment_id=" + attachment.id)
			.then((response) => {
				attachment.url = response.url;
				AppStore.actions.addAttachmentPreview(attachment);
			})
			.catch((err) => {
				console.error(err);
				AppStore.snackbar.start("Attachment download failed.", "error");
			});
	};
	let tryDeleteAttachment = (attachment) => {
		if (confirmDialog) {
			confirmDialog.onConfirm = () => {
				deleteAttachment(attachment);
			};
			confirmDialog.visible.set(true);
		}
		else {
			deleteAttachment(attachment);
		}
	};
	let deleteAttachment = (attachment) => {
		deleting = true;
		API.delete("/comments/comment/" + comment.id + "/attachment?attachment_id=" + attachment.id)
			.then((response) => {
				deleting = false;
				console.log(response);
				comment.setData(response);
				$lastUpdated = Date.now();
				AppStore.snackbar.start("Attachment deleted successfully.", "success");
			})
			.catch((err) => {
				console.error(err);
				deleting = false;
				AppStore.snackbar.start("Attachment deletion failed.", "error");
			})
			.finally(()=>{
				if (confirmDialog) {
					confirmDialog.visible.set(false);
				}
			});
	}
	let canDeleteAttachment = (attachment) => {
		if (comment.thread.locked === 1) { return false };
		// Can delete if:
		// * they are the author
		// * TODO: they are the company... admin? or some other new permission. 
		// * they are a geollect cms admin / comment
		return User.hasAnyOfFeatures([Feature.ADMIN.EDIT, Feature.ADMIN.COMMENTS.EDIT]) || User.getCurrentUser().id == attachment.userId;
	}
	let canDeleteComment = (comment) => {
		if (comment.thread.locked === 1) { return false };
		return (User.hasAnyOfFeatures([Feature.ADMIN.EDIT, Feature.ADMIN.COMMENTS.EDIT]) || User.getCurrentUser().id == comment.userId) && index > 0;
	};
	let canAddAttachment = (comment) => {
		if (comment.thread.locked === 1) { return false };
		return (User.hasAnyOfFeatures([Feature.ADMIN.EDIT, Feature.ADMIN.COMMENTS.EDIT]) || User.getCurrentUser().id == comment.userId);
	};

</script>
<style>
	.message-container p,
	.message-container p b {
		font-size:14px !important;
		line-height:22px !important;
		padding:0px !important;
		margin:0px !important;
	}
	.message-container p.date {
		color:#777 !important;
		font-style: italic !important;
	}
	.message-container .attachment {
		padding:6px;
		border:1px solid grey;
		border-radius:3px;
		margin-top:5px;
		overflow:auto;
	}
	.message-container .attachment.attachment-type-image {

	}
	.message-container .attachment span {
		display:block;
		line-height:20px;
		cursor:default;
	}
	.message-container .attachment span.btn {
		border-radius:3px;
		padding:4px;
		font-size: 12px;
		line-height: 12px;
		cursor:pointer;
	}
	.message-container .attachment span.btn.download {
		margin-left:4px;
		background-color: var(--mdc-theme-secondary);
		color: var(--mdc-theme-on-secondary);
	}
	.message-container .attachment span.btn.delete {
		margin-left:4px;
		background-color: var(--mdc-theme-error);
		color: var(--mdc-theme-on-error);
	}
	.message-container .attachment span span.icon { 
		display:inline-block;
		vertical-align:bottom;	
	}
	
	.message-container .btn-sml {
		font-size: 12px !important;
		float: right;
		/* margin-left: 4px; */
		margin-top: 2px;
		height:18px;
		cursor:pointer;
	}
	.message-container .btn-sml div.tooltip-container {
		font-size: 12px !important;
	}
</style>

<p style="display:none;">{$lastUpdated}</p>
<div class='tooltip-container' style="display:none;">...</div>

<div class="msgbox mb-10 oa message-container" style="background-color:white">
	<div class="oa">
		<p class='fl'><b>{comment.fromUserName} ({comment.fromUserCompanyName})</b></p>
		{#if canDeleteComment(comment) && showEditTools}
			{#if deleting}
				<p class='fr'>&nbsp;...</p>
			{:else}
				<Tooltip cls="fs-12 ml-0 fr" text={"Delete"}><button class='btn btn-sml bg-error' on:click={() => { deleteComment(comment.id); }}>x</button></Tooltip>
			{/if}
		{/if}
		{#if canAddAttachment(comment) && showEditTools}
			<!-- <p class='fr'>&nbsp;<Tooltip cls="fs-10" inline text={(!showingAttachmentForm)?"Add Attachment":"Close"}><a href="/" style="color:blue;" on:click|preventDefault={()=>{ toggleAttachmentForm(comment.id); }}>{#if !showingAttachmentForm}+{:else}-{/if}</a></Tooltip></p> -->
			<Tooltip cls="fs-12 fr" text={(!showingAttachmentForm)?"Add Attachment":"Close"}><button class='btn btn-sml fr ml-5 bg-info' on:click={()=>{ toggleAttachmentForm(comment.id); }}>{#if !showingAttachmentForm}+{:else}-{/if}</button></Tooltip>
		{/if}
		<p class='fr date' title={comment.fullTimestamp}>{comment.relativeTime}</p>
		
		
	</div>
	<p>{comment.message}</p>
	
	{#if comment.attachments}
		{#each comment.attachments as attachment (attachment.id)}
			<div class={"attachment attachment-type-"+attachment.fileType}>
				<span class='fl' style="width:60%;">
					<span class='icon material-icons'>{attachment.materialIcon}</span><span style="width:85%; text-overflow:ellipsis; white-space:nowrap; overflow-y:hidden; display:inline-block;">{attachment.fileName}</span>
				</span>
				{#if showEditTools}
					{#if canDeleteAttachment(attachment)}
						<!-- <Tooltip text={"Delete Attachment"}> -->
							<span title="Delete Attachment" class='fr btn delete' on:click={()=>{ tryDeleteAttachment(attachment); }}>X</span>
						<!-- </Tooltip> -->
					{/if}
					<span class='fr btn download' on:click={()=>{ downloadAttachment(attachment); }}>Download</span>
					{#if attachment.isImage()}
						<span class='fr btn download' on:click={()=>{ viewImageAttachment(attachment); }}>View</span>
					{/if}
				{/if}
				
			</div>
			<p style="display:none">{$lastUpdated}</p>
		{/each}
	{/if}
	
	
	{#if showingAttachmentForm}
		{#if files.accepted.length === 0}
			<div class="mt-5">
				<Dropzone on:drop={handleFilesSelect} multiple={false} accept=".pdf,.jpg,.png" />
			</div>
		{:else if files.accepted.length === 1 && $parsingFile === LoadState.LOADED}
			<p><b>Attachment:</b> {#if files.accepted.length === 1}{files.accepted[0].name} <a href="/" style="color:red;" on:click|preventDefault={clearAttachmentForm}>X</a>{/if}</p>
			<Button on:click={submitAttachment} fullwidth color="secondary" variant="unelevated" style='margin-top:10px;width:100%;'>
				<Label>Add Attachment</Label>
			</Button>
		{/if}
	{/if}

</div>